import { createReducer, on } from '@ngrx/store';
import { PublicActions } from './public.actions';

export interface IPublicState {
  init: boolean;
  publicSystemParams: Record<string, string> | null;
}

export const initialState: IPublicState = {
  init: false,
  publicSystemParams: null,
};

export const publicReducer = createReducer(
  initialState,
  on(PublicActions.initEnd, (state, payload) => ({
    ...state,
    publicSystemParams: payload.publicSystemParams,
    init: true,
  })),
  on(PublicActions.requestPublicSystemParamsSuccess, (state, payload) => ({
    ...state,
    publicSystemParams: payload.publicSystemParams,
  })),
);
